module.exports = __webpack_public_path__ + "img/griquas-logo-icon.2e706af0.png";